"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useBreakpoints = exports.WithBreakpoints = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = require("react");

var _reactMedia = require("react-media");

var _context = require("../context");

var _helpers = require("../helpers");

var _utils = require("../utils");

var _utils2 = require("./utils");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var useBreakpoints = function useBreakpoints() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$defaultSize = _ref.defaultSize,
      defaultSize = _ref$defaultSize === void 0 ? 'l' : _ref$defaultSize,
      propsMap = _ref.propsMap;

  var _useContext = (0, _react.useContext)(_context.StencilContext),
      breakpoints = _useContext.theme.breakpoint;

  var sizes = Object.keys(breakpoints); // If this is being rendered in a window context, use that
  // window as the target window.

  var _useContext2 = (0, _react.useContext)(_helpers.WindowContext),
      targetWindow = _useContext2.window; // For server side rendering, the first render won't be in a real DOM,
  // so media queries won't work. We allow the consumer to specify a default
  // configuration in that case. Once the app renders in the client, the media
  // query will overwrite this default value with the real one. This won't
  // affect apps that don't use SSR.


  var defaultMatches = sizes.reduce(function (defaults, size) {
    return _objectSpread(_objectSpread({}, defaults), {}, (0, _defineProperty2.default)({}, size, size === defaultSize));
  }, {});
  var queries = sizes.reduce(function (out, size) {
    return _objectSpread(_objectSpread({}, out), {}, (0, _defineProperty2.default)({}, size, (0, _utils2.buildMediaQuery)(breakpoints[size])));
  }, {});
  var matches = (0, _reactMedia.useMedia)({
    queries: queries,
    defaultMatches: defaultMatches,
    targetWindow: targetWindow
  });
  var mappedProps = (0, _react.useMemo)(function () {
    if (!propsMap) {
      return undefined;
    }

    var matchedSize = sizes.find(function (size) {
      return !!matches[size];
    }) || defaultSize;
    return propsMap[matchedSize] || propsMap.default;
  }, [propsMap, matches, sizes, defaultSize]);
  return {
    matches: matches,
    props: mappedProps
  };
};

exports.useBreakpoints = useBreakpoints;
var WithBreakpoints = (0, _utils.hookToFAC)(useBreakpoints);
exports.WithBreakpoints = WithBreakpoints;